import ChatBubble from '../../../../ChatBubble';
import { format } from 'date-fns';
import React from 'react';
import Avatar from '../Avatar';
import { FooterTime } from './style';
export var Footer = function (_a) {
    var message = _a.message, nextMessage = _a.nextMessage, members = _a.members, shouldShowAvatars = _a.shouldShowAvatars;
    var currentMembers = message.currentMembers;
    return (React.createElement(ChatBubble.Footer, null,
        React.createElement(FooterTime, { size: "xxs", color: "shade.700", mt: "xxxs" }, format(message.dateCreated, 'h:mm aaa')),
        shouldShowAvatars &&
            currentMembers.map(function (member) {
                return React.createElement(Avatar, { key: member.identity, member: member, isFooter: true });
            })));
};
//# sourceMappingURL=index.js.map